import React from 'react';
import { Button } from 'primereact/button';
import { useHistory, useParams } from 'react-router-dom/cjs/react-router-dom.min';

export default function Header() {
  const history = useHistory();
  const { automationRuleId } = useParams();

  return (
    <div className="px-6 py-2 border-b border-gray-100 d-flex align-items-center">
      <Button className="p-button-text" onClick={() => history.goBack()} icon="pi pi-arrow-left" />
      <div className="d-flex flex-column">
        <h1 className="title font-semibold gray-900">{automationRuleId ? 'Update' : 'Create'} Automation Workflow</h1>
      </div>
    </div>
  );
}
